import React from 'react';

import * as S from './styles';

const Slide1: React.FC = () => {
  return (
    <S.Container>
      <S.Headline>
        Alta
        <br />
        Velocidade
      </S.Headline>
      <S.Text>
        Com duas estreias à vista e planos para 2023, Alice Wegmann acelera rumo
        ao estrelato a bordo de looks esportivos com um quê fetichista.
      </S.Text>
      <S.Wrapper>
        <S.Subtitle>
          Macacão, R$ 2.800, e jaqueta, R$ 2.800, ambos Bold Strap. Botas, Louis
          Vuitton, R$ 11 mil (usadas em todas as fotos).
        </S.Subtitle>
        <S.Caption>
          <span>fotos:</span> Hugo Toni
          <br />
          <span>edição de moda:</span> Davi Ramos e<br /> Flavia Pommianosky
        </S.Caption>
      </S.Wrapper>
    </S.Container>
  );
};

export { Slide1 };
